<template>
    <v-container>
        <v-layout>
            <v-flex xs4 md3>
                <v-layout mb-3>
                    <v-flex>
                        <v-menu content-class="menu-card mt-2 app-content flex"
                                min-width="450px"
                                transition="scale-transition"
                                :close-on-content-click="false"
                                offset-y
                                full-width
                                v-model="popupFiltro">
                            <v-btn slot="activator" class="btn-default" color="dark" large outline>
                                <v-icon color="primary">lnr-funnel</v-icon>
                                <div class="pl-1">Filtrar</div>
                            </v-btn>
                            <v-layout column class="card">
                                <v-flex mb-4>
                                    <v-label>Data de criação</v-label>
                                    <v-text-field mb-4 ref="textField" v-model="filtro.data_hora_criacao" flat solo
                                                  validate-on-blur
                                                  mask="##/##/####"
                                                  return-masked-value
                                                  @keyup.enter="filtrar"></v-text-field>
                                </v-flex>
                                <v-flex mb-4>
                                    <v-label>E-mail</v-label>
                                    <v-text-field ref="textField" v-model="filtro.email" flat solo hide-details
                                                  maxlength="100"
                                                  @keyup.enter="filtrar"></v-text-field>
                                </v-flex>
                                <v-flex mb-4>
                                    <v-label>Nome</v-label>
                                    <v-text-field ref="textField" v-model="filtro.nome" flat solo hide-details
                                                  maxlength="100"
                                                  @keyup.enter="filtrar"></v-text-field>
                                </v-flex>
                                <v-layout mt-3 justify-center>
                                    <v-flex xs4>
                                        <v-btn class="btn-default" color="dark" outline @click="limpar">Limpar</v-btn>
                                    </v-flex>
                                    <v-flex xs4>
                                        <v-btn class="btn-default primary" @click="filtrar">Filtrar</v-btn>
                                    </v-flex>
                                </v-layout>
                            </v-layout>
                        </v-menu>
                    </v-flex>
                    <v-flex mb-6 v-if="selected.length == 0" class="text-xs-right">
                        <v-btn class="btn-default shrink" color="primary" large @click="distribuirLeads">
                            Distribuição Automática
                        </v-btn>
                    </v-flex>
                </v-layout>
            </v-flex>
            <v-layout mb-6 v-if="selected.length > 0">
                <v-flex offset-xs7 xs4>
                    <v-form ref="form">
                        <autocomplete
                                placeholder="Nenhum vendedor"
                                :items="vendedores"
                                v-model="vendedor"
                                v-bind:style="{'margin-top':'5px'}"
                                item-text="nome"
                                min-length="0"
                                item-value="id_vendedor"
                                :rules="[rules.required]">
                        </autocomplete>
                    </v-form>
                </v-flex>
                <v-flex xs3>
                    <v-btn class="btn-default" color="primary" large @click="enviarLeads">
                        Enviar
                    </v-btn>
                </v-flex>
            </v-layout>
        </v-layout>
        <v-layout column class="card table">
            <data-table v-model="selected" ref="table" url="/admin/leads"
                        :filter="dtFiltro"
                        :headers="headers"
                        :sortBy="'data_hora_criacao'"
                        :params="{pagination: pagination,
                                  id_usuario: id_usuario,
                                  id_unidade_negocio: id_unidade_negocio}"
                        item-key="id_lead"
                        select-all>
                <template slot="items" slot-scope="{ item }">
                    <td>{{ item.data_hora_criacao | moment }}</td>
                    <td>{{ item.email }}</td>
                    <td>{{ item.nome }}</td>
                    <td>{{ item.login }}</td>
                    <td>{{ maskCEP(item.cep) }}</td>
                    <td>{{ item.produto }}</td>
                    <td>{{ item.credito | money }} / {{ item.parcela | money}} </td>
                </template>
            </data-table>
        </v-layout>
    </v-container>
</template>

<script>
import Rules from '../plugins/validation'
import DataTable from '../components/DataTable'
import moment from 'moment'
import { alert, sleep, error } from '../plugins/helpers'
import masker from 'vue-the-mask/src/masker'
import { tokens } from 'vue-the-mask'

/**
   * @var item
   * @type {object}
   * @property {number} id_unidade_negocio
   * @property {string} codigo
   * @property {string} nome
   */

export default {
  components: { DataTable },
  data: () => ({
    selected: [],
    pagination: { sortBy: 'nome' },
    checkBox: true,
    cidades: [],
    headers: [
      { text: 'Data Criação', value: 'data_hora_criacao' },
      { text: 'E-mail', value: 'email' },
      { text: 'Nome / Razão Social', value: 'nome' },
      { text: 'Vendedor', value: 'vendedor' },
      { text: 'Cep', value: 'cep' },
      { text: 'Produto de interesse', value: 'produto' },
      { text: 'Crédito / Parcela Simulados', value: '', sortable: false }
    ],
    filtro: {
      data_hora_criacao: '',
      email: '',
      cidades: [],
      nome: '',
      'id_cidade': []
    },
    dtFiltro: {},
    popupFiltro: false,
    vendedores: [],
    vendedor: {},
    id_usuario: '',
    id_unidade_negocio: ''
  }),
  computed: {
    rules: () => Rules
  },
  filters: {
    moment: function (date) {
      return moment(date).format('DD/MM/YYYY HH:mm:ss')
    },
    money: function (value) {
      return value === '-' || value <= 0 ? '-' : parseFloat(value).toFixed(2)
    }
  },
  watch: {
    popupFiltro (open) {
      if (open) {
        sleep(100).then(() => this.$refs.textField.focus())
      }
    }
  },
  methods: {
    filtrar () {
      this.popupFiltro = false
      this.dtFiltro = { ...this.filtro }
    },
    limpar () {
      this.filtro = {}
      this.filtrar()
    },
    enviarLeads () {
      if (this.vendedor > 0) {
        let params = {}
        params.ids_lead = []
        for (let lead of this.selected) {
          params.ids_lead.push(lead.id_lead)
        }
        params.id_vendedor = this.vendedor
        params.id_unidade_negocio = this.id_unidade_negocio

        this.$http.post(`/admin/leads`, {
          ids_lead: params.ids_lead,
          id_vendedor: params.id_vendedor,
          id_unidade_negocio: params.id_unidade_negocio
        }).then(r => {
          alert({
            text: `Lead distribuído com sucesso`,
            buttons: {
              'OK': () => { this.$router.go() }
            }
          })
        }).catch(this.fail)
      } else {
        alert('Nenhum vendedor foi selecionado')
      }
    },
    distribuirLeads () {
      alert({
        text: `Tem certeza que deseja distribuir TODOS os seus leads?`,
        buttons: {
          'Cancelar': () => true,
          'Distribuir': () => {
            this.$http.post(`/admin/leads/distribuicao`, {
              id_unidade_negocio: this.id_unidade_negocio,
              id_usuario: this.id_usuario
            }).then(() => {
              alert(`Leads distribuídos com sucesso!`)
              this.dtFiltro = { ...this.filtro }
            }).catch(err => {
              error(err, 'Não foi possível distribuir os leads.')
            })
          }
        }
      })
    },
    maskCEP (cep) {
      return masker(`${cep}`, '#####-###', true, tokens)
    }
  },
  mounted () {
    this.id_usuario = this.$session.get('id_usuario')
    this.id_unidade_negocio = this.$session.get('id_unidade_negocio')
    this.$http.get('/admin/hierarquias/vendedores', {
      params: { id_usuario: this.id_usuario }
    }).then((r) => {
      r.data.forEach(r => {
        if (r.status === 'ativo') { this.vendedores.push(r) }
      })
    }).catch(this.fail)
  }
}
</script>

<style scoped>

</style>
